import { createContext, useContext, useState, useEffect } from "react";
import { toast } from "sonner";

const FlashMessageContext = createContext({});
const { Provider, Consumer } = FlashMessageContext;

const FlashMessageProvider = ({ children, ...props }) => {
  const [openFlash, setOpenFlash] = useState(false);
  const [severity, setSeverity] = useState("");
  const [flashMessage, setFlashMessage] = useState("");

  useEffect(() => {
    if (openFlash && flashMessage) {
      if (severity === "error") {
        toast.error(flashMessage);
      } else if (severity === "warning") {
        toast.warning(flashMessage);
      } else {
        toast.success(flashMessage);
      }
      // Reset to prevent repeated fires
      setOpenFlash(false);
      setFlashMessage("");
    }
  }, [openFlash, flashMessage, severity]);

  return (
    <Provider
      value={{
        setOpenFlash,
        setSeverity,
        setFlashMessage,
      }}
      {...props}
    >
      {children}
    </Provider>
  );
};

const useFlashMessageContext = () => {
  const state = useContext(FlashMessageContext);
  if (state === undefined) {
    throw new Error(
      "useFlashMessageContext must be called within FlashMessageProvider"
    );
  }

  return {
    ...state,
  };
};

export {
  FlashMessageProvider,
  Consumer as FlashMessageConsumer,
  useFlashMessageContext,
};

export default FlashMessageContext;
